import React from 'react'
import {
  FetchBillingResponse,
  PaymentConfigurationCodeEnum,
} from '../../../../swagger'
import { CanAccess } from '../../../Elements/Access'
import { useAuth } from '../../../Routes/AuthProvider'
import { ACTING_AS_PARENT } from '../../../../utils/constants'
import { NavigationCard } from '../../../Elements/NavigationCard'
import { useUser } from '../../../../UserContext'
import ParentBillingView from './ParentBillingView'
import ActorBillingView from './ActorBillingView'
import { BillingHistorySummaryTableVariant } from '../BillingHistorySummaryTable'
import { useLocation } from 'react-router'

export type DefaultBillingViewProps = {
  billingData: FetchBillingResponse
  triggerRefetch: () => void
}

const DefaultBillingView: React.FC<DefaultBillingViewProps> = ({
  billingData,
  triggerRefetch,
}) => {
  const { userDetails } = useAuth()
  const location = useLocation()
  const { uniqueInactiveUserRoles } = useUser()

  const isViewingBillingHistory = /\/account\/billing\/history\/\d+/.test(
    location.pathname
  )

  const achDiscount =
    billingData?.configurations.find(
      (config) => config.code === PaymentConfigurationCodeEnum.AchDiscount
    )?.amount ?? '0.00'

  const isParent = userDetails.actingAs === ACTING_AS_PARENT
  const showNavigationCard =
    uniqueInactiveUserRoles.length > 0 && !isViewingBillingHistory
  const showParentView = !isViewingBillingHistory && isParent
  const showActorView = !isParent

  return (
    <CanAccess I="billing" on="Feature">
      {showNavigationCard && (
        <NavigationCard
          icons={{
            startIcon: 'history_icon',
            endIcon: 'navigate_next_icon',
          }}
          title="Billing History"
          subtitle="View billing information from expired roles."
          navigateTo="/account/billing/roles"
        />
      )}

      {showParentView && (
        <ParentBillingView
          billingData={billingData}
          triggerRefetch={triggerRefetch}
          achDiscount={achDiscount}
        />
      )}

      {showActorView && (
        <ActorBillingView
          achDiscount={achDiscount}
          billingData={billingData}
          triggerRefetch={triggerRefetch}
          variantForBillingHistorySummaryTable={
            BillingHistorySummaryTableVariant.LicensingPayments
          }
        />
      )}
    </CanAccess>
  )
}

export default DefaultBillingView
